<template>
  <div class="select">
    <select
      v-model="selected"
      @change="handleClick($event.target.value)"
    >
      <option
        v-for="option in options.data"
        :value="option"
      >
        {{ option }}
      </option>
    </select>
  </div>
</template>
<script>

export default {
  data () {
    return {
      selected: '$101 - $150',
      options: {
        data: [
          '$0 - $50',
          '$51 - $100',
          '$101 - $150',
          '$151 - $200',
          '$201 - $300',
          '$301 - $400',
          '$401+'
        ]
      }
    }
  },
  mounted () {
    this.$emit('input', this.selected)
  },
  methods: {
    handleClick (value) {
      this.selected = value
      this.$emit('input', this.selected)
    }
  }
}
</script>
